import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify'; // path to vuetify export
import moment from 'moment-timezone';
// Import Vue 3 compatible GTM directives
import { dataanchor, databutton, dataselect, datainput } from '@/directives/gtm-directives';
import '@lottiefiles/lottie-player';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import { vMaska } from 'maska';

import './assets/scss/main.scss';

// Import Vue 3 compatible carousel
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

// Make Bootstrap available globally for migration
window.bootstrap = bootstrap;
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import '@aws-amplify/ui-vue/styles.css';

// Configure compatibility mode if needed
if (process.env.VUE_APP_VUE_VERSION === 'compat') {
  const { configureCompat } = require('vue');
  configureCompat({
    // Add compat feature toggles here as migration warnings surface.
    mode: 'legacy',
  });
}

moment.tz.setDefault('America/Phoenix');

// Toast configuration options
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
};

// Directives will be registered on the app instance

// v-tooltip removed - using Bootstrap tooltips instead

import { createGtm } from '@gtm-support/vue-gtm';

// Vue 3 no longer has productionTip
// Debug and devtools config are handled differently in Vue 3

// GTM configuration
const gtm = createGtm({
  id: 'GTM-T6RNSMQ',
  enabled: true,
  debug: true,
  vueRouter: router,
});

// Carousel3d will be registered on the app instance

// Note: setAllSites is now called after authentication in LoggedIn.vue
// to ensure we have a valid auth token for API calls

try {
  // Configure Amplify with base Auth settings
  // Note: We DON'T configure API here because the API uses Bearer token + API key auth,
  // not AWS Signature V4. We handle API calls manually via fetch in amplifyCompat.js
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.VUE_APP_AWS_USER_POOLS_ID,
        userPoolClientId: process.env.VUE_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: process.env.VUE_APP_AWS_USER_POOLS_DOMAIN,
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [process.env.VUE_APP_SIGN_IN_URL],
            redirectSignOut: [process.env.VUE_APP_SIGN_OUT_URL],
            responseType: 'code',
          },
        },
      },
    },
  });
} catch (error) {
  console.error('Failed to configure Amplify v6:', error);
}

/**
 * Note: Auth.configure() is no longer needed in Amplify v6
 * All configuration is done through Amplify.configure()
 */

// Create and configure the Vue 3 app
const app = createApp(App);

// Register plugins
app.use(router);
app.use(store);
app.use(vuetify);
app.use(Toast, toastOptions);
app.use(gtm);
// Register Vue 3 carousel components
app.component('Carousel', Carousel);
app.component('CarouselSlide', Slide);
app.component('CarouselPagination', Pagination);
app.component('CarouselNavigation', Navigation);

// Register directives
app.directive('maska', vMaska);
app.directive('dataanchor', dataanchor);
app.directive('databutton', databutton);
app.directive('data-input', datainput);
app.directive('data-select', dataselect);

// Mount the app
app.mount('#app');
